import { Menu, MenuItem, SubMenu } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import React, { useCallback } from 'react';

export interface MenuItemType {
    label: string;
    title?: string;
    action?: () => void;
    disabled?: boolean;
    disabledReason?: string;
    submenu?: MenuItemType[];
    icon?: string;
    shortcut?: string;
}

interface MenuDropdownProps {
    label: string;
    items: MenuItemType[];
}

const getLabelTitle = (item: MenuItemType) => {
    return item.disabled && item.disabledReason ? item.disabledReason : item.title;
};

export const MenuDropdown: React.FC<MenuDropdownProps> = React.memo(({ label, items }) => {
    const renderMenuItem = useCallback((item: MenuItemType, index: number) => {
        if (item.submenu) {
            return (
                <SubMenu
                    key={index}
                    label={
                        <span className='flex items-center' title={getLabelTitle(item)}>
                            <span className='w-4 text-xs text-center mr-2'>{item.icon || ' '}</span>
                            {item.label}
                        </span>
                    }
                    disabled={item.disabled}
                >
                    {item.submenu.map((subItem, subIndex) => (
                        <MenuItem
                            key={subIndex}
                            onClick={() => {
                                if (!subItem.disabled && subItem.action) {
                                    subItem.action();
                                }
                            }}
                            disabled={subItem.disabled}
                            className={subItem.disabled ? 'opacity-50 cursor-not-allowed' : ''}
                        >
                            <span className='flex items-center justify-between w-full'>
                                <span className='flex items-center' title={getLabelTitle(subItem)}>
                                    <span className='w-4 text-xs text-center mr-2'>{subItem.icon || ' '}</span>
                                    {subItem.label}
                                </span>
                                {subItem.shortcut && (
                                    <span className='text-xs text-vscode-text-muted ml-4'>{subItem.shortcut}</span>
                                )}
                            </span>
                        </MenuItem>
                    ))}
                </SubMenu>
            );
        }

        return (
            <MenuItem
                key={index}
                onClick={() => {
                    if (!item.disabled && item.action) {
                        item.action();
                    }
                }}
                disabled={item.disabled}
                className={item.disabled ? 'opacity-50 cursor-not-allowed' : ''}
            >
                <span className='flex items-center justify-between w-full'>
                    <span className='flex items-center' title={getLabelTitle(item)}>
                        <span className='w-4 text-xs text-center mr-2'>{item.icon || ' '}</span>
                        {item.label}
                    </span>
                    {item.shortcut && <span className='text-xs text-vscode-text-muted ml-4'>{item.shortcut}</span>}
                </span>
            </MenuItem>
        );
    }, []);

    return (
        <Menu
            menuButton={
                <button className='px-2 py-1 text-vscode-text-secondary rounded szh-menu-button'>{label}</button>
            }
        >
            {items.map(renderMenuItem)}
        </Menu>
    );
});
